import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx } from "react/jsx-runtime";
import { useNavigate } from 'react-router-dom';
import { useOverlayContext } from 'seagull/components/OverlayContext/OverlayContext';
import { draftsScopedToRun } from '~/pages/DraftsDashboard/bulkRunScope';
import { BulkCreateResultsModal } from '../../../../BulkCreateResultsModal/BulkCreateResultsModal';
import { useTasksDrawer, useTasksDrawerStoreApi } from '../../../../tasksDrawerStore';
const runResultsPropsOf = (task, onSendStarted)=>({
        runId: task.jobId,
        jobName: task.jobName,
        runCancelled: task.status === 'cancelled',
        onSendStarted
    });
const reviewRequestOf = (dismissModal, closeDrawer)=>()=>{
        closeDrawer();
        dismissModal(true);
    };
const resultsOf = (props, closeDrawer)=>function RunResults(param) {
        let { dismissModal } = param;
        return /*#__PURE__*/ _jsx(BulkCreateResultsModal, _object_spread_props(_object_spread({}, props), {
            onClose: ()=>dismissModal(false),
            onReviewDrafts: reviewRequestOf(dismissModal, closeDrawer)
        }));
    };
export const useOpenCreateRunResults = (task)=>{
    const { showModal } = useOverlayContext();
    const { closeDrawer } = useTasksDrawer();
    const navigate = useNavigate();
    const drawerStore = useTasksDrawerStoreApi();
    const registerSendForFeedback = (batchId)=>drawerStore.getState().registerFeedbackPrompt(batchId, {
            feature: 'bulkCreateProposals',
            contextId: batchId
        });
    const content = resultsOf(runResultsPropsOf(task, registerSendForFeedback), closeDrawer);
    return (event)=>{
        event === null || event === void 0 ? void 0 : event.stopPropagation();
        void showModal({
            biName: 'bulk_create_results',
            content
        }).then((reviewRequested)=>{
            if (reviewRequested) navigate(draftsScopedToRun(task.jobId));
        });
    };
};
